/* brd-2026-footer.js
 *
 * Wires up the mobile accordion behaviour for footer link_list menus.
 *
 * Each `.footer-block--menu` inside `[data-brd-footer="true"]` gets:
 *   1. A `.brd-footer-menu__toggle` button that wraps the heading
 *      (Liquid is responsible for rendering this — see footer.liquid).
 *      JS only manages `aria-expanded` and the `.brd-footer-menu--open`
 *      class on the parent to drive CSS.
 *   2. Click handler that toggles the open state on viewports < 750px.
 *      On desktop the toggle is non-interactive (CSS does the work) and
 *      this handler short-circuits.
 *   3. A `max-height` inline style is set so the CSS transition has a
 *      target to animate to. We set it to the scrollHeight at the moment
 *      of opening so the height fits the actual content.
 *
 * Why a button-driven open state instead of <details>? <details> can't be
 * forced open via CSS at desktop widths in a cross-browser way — collapsed
 * <details> hides its non-summary content via internal display logic that
 * `display: block` doesn't override. A button + aria-expanded model lets
 * CSS show the content unconditionally on desktop.
 *
 * Created: 2026-05-04
 */
(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 750;

  function isMobile() {
    return window.matchMedia('(max-width: ' + (DESKTOP_BREAKPOINT - 0.02) + 'px)').matches;
  }

  function setOpen(menu, toggle, list, open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.classList.toggle('brd-footer-menu--open', open);
    if (!list) return;

    if (open) {
      // Set max-height to the natural content height so the transition has
      // a target. Read it AFTER the .brd-footer-menu--open class is on so
      // any padding-block change is included in scrollHeight.
      list.style.maxHeight = list.scrollHeight + 'px';
    } else {
      list.style.maxHeight = '';
    }
  }

  function initMenu(menu) {
    var toggle = menu.querySelector('.brd-footer-menu__toggle');
    var list = menu.querySelector('.footer-block__details-content');
    if (!toggle || !list) return;

    // Closed by default on mobile.
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', function (e) {
      // On desktop the toggle is rendered as a static heading — bail.
      if (!isMobile()) return;
      e.preventDefault();
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      setOpen(menu, toggle, list, !isOpen);
    });

    // Resize handling: on viewport changes, clear inline max-height so
    // CSS rules take over (desktop shows the full list, mobile re-collapses).
    window.addEventListener('resize', function () {
      if (!isMobile()) {
        list.style.maxHeight = '';
        toggle.setAttribute('aria-expanded', 'true');
        menu.classList.remove('brd-footer-menu--open');
      } else {
        // re-collapse on shrink to mobile
        if (toggle.getAttribute('aria-expanded') !== 'true') {
          list.style.maxHeight = '';
        }
      }
    });
  }

  function init() {
    var footer = document.querySelector('[data-brd-footer="true"]');
    if (!footer) return;
    var menus = footer.querySelectorAll('.footer-block--menu');
    Array.prototype.forEach.call(menus, initMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
